export const STATE_TERMS: [string, string][] = [
  ['Alabama', 'Unlawful Detainer'],
  ['Arizona', 'Special Detainer'],
  ['Arkansas', 'Unlawful Detainer'],
  ['California', 'Unlawful Detainer'],
  ['Colorado', 'Forcible Entry and Detainer (FED)'],
  ['Connecticut', 'Summary Process'],
  ['Delaware', 'Summary Possession'],
  ['Florida', 'Action for Possession / Eviction'],
  ['Georgia', 'Dispossessory Proceeding'],
  ['Idaho', 'Unlawful Detainer'],
  ['Illinois', 'Eviction Action'],
  ['Indiana', 'Eviction / Complaint for Possession'],
  ['Iowa', 'Forcible Entry and Detainer (FED)'],
  ['Kansas', 'Forcible Detainer'],
  ['Kentucky', 'Forcible Detainer'],
  ['Louisiana', 'Rule for Possession'],
  ['Maine', 'Forcible Entry and Detainer'],
  ['Maryland', 'Failure to Pay Rent / Tenant Holding Over'],
  ['Massachusetts', 'Summary Process'],
  ['Michigan', 'Summary Proceedings'],
  ['Minnesota', 'Eviction Action'],
  ['Mississippi', 'Unlawful Entry and Detainer'],
  ['Missouri', 'Unlawful Detainer / Rent and Possession'],
  ['Montana', 'Unlawful Detainer'],
  ['Nebraska', 'Forcible Entry and Detainer'],
  ['Nevada', 'Unlawful Detainer'],
  ['New Hampshire', 'Landlord-Tenant Writ'],
  ['New Jersey', 'Summary Dispossess'],
  ['New Mexico', 'Petition for Restitution'],
  ['New York', 'Summary Proceeding'],
  ['North Carolina', 'Summary Ejectment'],
  ['North Dakota', 'Eviction / Forcible Detainer'],
  ['Ohio', 'Forcible Entry and Detainer'],
  ['Oklahoma', 'Forcible Entry and Detainer'],
  ['Oregon', 'Forcible Entry and Detainer'],
  ['Pennsylvania', 'Landlord-Tenant Complaint'],
  ['Rhode Island', 'Eviction'],
  ['South Carolina', 'Ejectment / Rule to Show Cause'],
  ['South Dakota', 'Forcible Entry and Detainer'],
  ['Tennessee', 'Detainer Warrant'],
  ['Texas', 'Eviction Suit'],
  ['Utah', 'Unlawful Detainer'],
  ['Vermont', 'Eviction / Ejectment'],
  ['Virginia', 'Unlawful Detainer'],
  ['Washington', 'Unlawful Detainer'],
  ['West Virginia', 'Unlawful Detainer'],
  ['Wisconsin', 'Eviction Action'],
  ['Wyoming', 'Forcible Entry and Detainer'],
]
